import './tooltip.scss'
// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const Tooltip = props => {
	const {
		position = '',
		isActive = false,
		closeIcon = true,
		listActive = [],
		idTooltip,
		setListActive,
		styles = { base: {}, mark: {} },
		children
	} = props

	if (!isActive) return null

	if (listActive && listActive.includes(idTooltip)) return null

	return (
		<span className={`a-tooltip ${position}`} style={styles.base}>
			{closeIcon && (
				<span className='a-tooltip__button' onClick={() => setListActive(idTooltip)}>
					<FontAwesomeIcon icon={faTimes} />
				</span>
			)}
			{children}
			<span className='a-tooltip__mark' style={styles.mark} />
		</span>
	)
}

export default Tooltip
